"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityConnectionTypeSetsDefault = void 0;
exports.entityConnectionTypeSetsDefault = {
  default: {
    name: 'Default',
    mappings: {
      Chapter: ["Person", "Organisation", "Location", "Team", "Sdg", "Challenge", "Trend", "Topic", "SubTopic"],
      Challenge: ["Feed", "KeyIssue", "Sdg", "Person", "Event", "Course", "Session", "Lesson", "FeedEntry", "ImpactStory", "Organisation", "Video", "Post"],
      Course: ["Lesson", "Person", "Challenge", "Trend", "Topic", "SubTopic"],
      KeyIssue: ["Feed", "Challenge", "InfluencingFactor", "Team", "FeedEntry", "Person", "Video", "Post"],
      Feed: ["Challenge", "KeyIssue", "Trend", "Topic", "SubTopic", "FeedEntry"],
      FeedEntry: ["Feed", "Challenge", "KeyIssue", "Trend", "Topic", "SubTopic", "Location", "Economy", "Organisation", "Person", "Site"],
      ImpactStory: ["Person", "Organisation", "Challenge", "MaturityStage", "Location", "Sdg"],
      Team: ["KeyIssue", "Person", "Organisation", "Challenge", "KeyIssue", "Trend", "Topic", "SubTopic"],
      Location: ["Economy", "Chapter", "Organisation", "Person", "Challenge", "KeyIssue", "Trend", "Topic", "SubTopic"],
      Economy: ["Location", "Person", "Challenge", "KeyIssue", "Trend", "Topic", "SubTopic"],
      Event: ["Session", "Person", "Challenge", "KeyIssue", "Trend", "Topic", "SubTopic", "Site"],
      Organisation: ["Person", "Location", "Chapter", "ImpactStory", "Team", "Challenge", "Sdg", "Site", "Post"],
      Sdg: ["Target", "Challenge", "Organisation", "Person", "Video"],
      Page: ["Slice", "Trend", "Topic", "SubTopic", "Challenge", "KeyIssue", "Person", "Site"],
      Person: ["Organisation", "Team", "Economy", "Post", "Video", "Page", "Location", "Sdg", "ImpactStory", "KeyIssue", "Challenge", "Topic", "SubTopic", "Trend", "FeedEntry", "Chapter", "Person", "Site"],
      // 
      Post: ["Feed", "Team", "Location", "Topic", "FeedEntry", "Chapter", "Person", "Event", "Site", "Organisation", "Challenge"],
      Trend: ["Feed", "Team", "Location", "Topic", "FeedEntry", "Chapter", "Person", "Page", "Event", "Video", "Post"],
      // 
      Topic: ["Feed", "Team", "Location", "Trend", "SubTopic", "FeedEntry", "Chapter", "Person", "Event", "Video", "Post"],
      // 
      SubTopic: ["Feed", "Team", "Location", "Topic", "FeedEntry", "Chapter", "Person", "Event", "Page", "Video", "Post"],
      // 
      Video: ["Person", "Organisation", "KeyIssue", "Challenge", "Trend", "Topic", "SubTopic", "Sdg", "Site", "Post"],
      Site: ["Page", "Post", "FeedEntry", "Person", "Organisation", "Event", "Video"],
      Slice: ["Page", "Trend", "Topic", "SubTopic", "Challenge", "KeyIssue", "Person", "Site", "Organisation", "Event", "Economy", "Video", "FeedEntry"]
    }
  }
};